import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Draft } from './draft';
import {QueryResult} from "@app/shared";

@Injectable()
export class DraftDataService {

    constructor(private http: HttpClient) { }

    getDraft(transaction: string): Observable<QueryResult> {
        const url = `/utils/draft-txns/self?transaction=${transaction}`;

        return this.http.get<QueryResult>(url);
    }

    saveDraft(draft: Draft): Observable<any> {
        const url = '/utils/draft-txns';

        return this.http.post(url, draft);
    }

    deleteDraft(draftId: number): Observable<any> {
        const url = `/utils/draft-txns/${draftId}`;

        return this.http.delete(url);
    }
}
